import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DdcCountryFlagComponent } from 'src/app/shared/ddc/ddc-country-flag/ddc-country-flag.component'
import { DaydicTypesIconNames } from 'src/app/shared/enums/enums'
import { Word } from 'src/app/shared/models/main/word'

export interface GroupNodeData {
  word: Word
}

@Component({
  selector: 'ddc-canvas-node-word',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
    DdcCountryFlagComponent,
  ],
  templateUrl: './word-node.component.html',
  styleUrls: ['./word-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasWordNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Word')
  icon = signal<string>(DaydicTypesIconNames.WORD)
}
